import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          <strong>Plus One Foundation</strong><br />
          Helping pass on what we received, carefully, responsibly, and in living form, to the next generation.
        </p>
        <p style={{ marginTop: '20px', fontSize: '14px' }}>
          TMT Learning Center is the flagship initiative of Plus One Foundation.<br />
          Email: info@tmtlearningcenter.org
        </p>
        <p style={{ fontSize: '12px', marginTop: '20px', color: '#aaa' }}>
          © 2026 Plus One Foundation. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;